export const OPEN_WINDOW = "OPEN_WINDOW"
export const CLOSE_WINDOW = "CLOSE_WINDOW"
export const TOGGLE_ANSWERPHONE = "TOGGLE_ANSWERPHONE"
export const TOGGLE_MENTION = "TOGGLE_MENTION"
export const TOGGLE_RANDOM_INTERVAL = "TOGGLE_RANDOM_INTERVAL"
export const TOGGLE_RANDOM_MESSAGES = "TOGGLE_RANDOM_MESSAGES"
export const TOGGLE_AUTODEBIT = "TOGGLE_AUTODEBIT"
export const CHANGE_MESSAGE_TEXT = "CHANGE_MESSAGE_TEXT"
export const SELECT_NUMBER_FROM_LIST = "SELECT_NUMBER_FROM_LIST"
export const CHANGE_INTERVAL = "CHANGE_INTERVAL"
export const DELETE_NUMBER = "DELETE_NUMBER"
export const TOGGLE_BOT = "TOGGLE_BOT"
export const LOGIN = "LOGIN"
export const LOGOUT = "LOGOUT"
export const SET_PHONES = "SET_PHONES"
export const SET_NUMBER_DATA = "SET_NUMBER_DATA"
export const DELETE_FROM_NUMBER_LIST = "DELETE_FROM_NUMBER_LIST"
export const CHANGE_INTERVAL_RANGE = "CHANGE_INTERVAL_RANGE"
export const CHANGE_TEXT_RESPONDER = "CHANGE_TEXT_RESPONDER"
export const SET_NEWS_LIST = "SET_NEWS_LIST"
export const SET_SUBSCRIPTION_PURCHASED = 'SET_SUBSCRIPTION_PURCHASED';
